module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "movefoldermodal",
    attrs: {
      "id": "move-folder-modal",
      "name": "move-folder-modal",
      "title": "Move folder",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Move",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.selectedFolder
    },
    on: {
      "shown": _vm.shown,
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel
    }
  }, [_c('folders-list', {
    attrs: {
      "folders": _vm.folders,
      "currentFolder": _vm.folder
    }
  }), _vm._v(" "), (_vm.selectedFolder) ? _c('span', [_vm._v("This folder will be moved to "), _c('strong', [_vm._v(_vm._s(_vm.selectedFolder.name))])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Moving\n  ")], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ea74ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MoveFolderModal.vue
// module id = 1013
// module chunks = 1